import { useCallback, useState } from "react";
import { useAppContext } from "./useAppContext";
import { useEnvContext } from "../contexts/env-context";

export const CDN_URL_COOKIE = "CreatorCdnUrl";

export function useCdnUrl() {
	const {
		platform: { cookies },
	} = useAppContext();

	const { isDebugBuild, homeUrl } = useEnvContext();

	const [cdnUrl, setCdnUrl] = useState<string | undefined>(cookies.getCookie(CDN_URL_COOKIE));

	const updateCdnUrl = useCallback(
		(value: string | undefined) => {
			if (value) {
				cookies.setCookie(CDN_URL_COOKIE, value, {
					path: "/",
					// 1 day
					minutesBeforeExpire: 1440,
				});
				setCdnUrl(value);
			} else {
				cookies.removeCookie(CDN_URL_COOKIE, { path: "/" });
			}

			const searchParams = new URLSearchParams(window.location.search);

			// Remove cdurl from querystring (all cases)
			[...searchParams.keys()].forEach((key) => {
				if (key.toLowerCase() === "cdnurl") {
					searchParams.delete(key);
				}
			});

			// Reload without cdnUrl in querystring
			window.location.search = searchParams.toString();
		},
		[cookies],
	);

	return [
		isDebugBuild || homeUrl.includes("stgr.cloud") ? cdnUrl : undefined,
		updateCdnUrl,
	] as const;
}
